import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { API_FAILURE, API_SUCCESS } from "../../../common/constants/ApiConstants";
import { BillingFormconstants } from "./DataEntryFieldsConstants";

export interface DataEntryDetailsRightPaneBillingSectionProps {
    readonly additionalChargeRecords: any;
    readonly releaseMethodId?: number;
    readonly feeScheduleId?: number;
    readonly shippingService: any;
    readonly isInternalRequest?: boolean;
    readonly updateDeliveryInstructionsStatus?: any;
    readonly certificationTemplateValue?: any;
    readonly changeFieldValue: (fieldName: string, value: any) => void;
    readonly setDisableShippingDropdown: (value: boolean) => void;
    readonly setShowDigitalFax: (value: boolean) => void;
    readonly setFeeScheduleId: (value: number) => void;
    readonly setDisableFeeScheduleDropdown: (value: boolean) => void;
    readonly setDisableReleaseMethodDropdown: (value: boolean) => void;
    readonly setDisableRemoveCertification: (value: boolean) => void;
}

/**
 * Billing-tab-scoped effects extracted from DataEntryDetailsRightPane.tsx
 * (Spec #34098 / F1a, AC13, Business Rule 16 - tidy-first structural refactor
 * #1). Headless by design: state ownership stays with the RightPane
 * orchestrator (passed down as props/setters) so behavior is unchanged -
 * only the *location* of these effects moves. Always rendered by the
 * orchestrator regardless of activeTabId, matching the pre-refactor firing
 * semantics (these effects previously ran on every RightPane render, not
 * only while the Billing tab was active).
 */
const DataEntryDetailsRightPaneBillingSection: React.FC<DataEntryDetailsRightPaneBillingSectionProps> = (props) => {
    useEffect(() => {
        if (Object.keys(props.additionalChargeRecords ?? {}).length) {
            props.changeFieldValue(BillingFormconstants.ADDITIONAL_CHARGES, props.additionalChargeRecords);
        }
    }, [props.additionalChargeRecords]);

    useEffect(() => {
        props.changeFieldValue(BillingFormconstants.RELEASE_METHODS, props.releaseMethodId);
        props.setDisableShippingDropdown(props.releaseMethodId === 2);
        props.setShowDigitalFax(props.releaseMethodId === 3);
    }, [props.releaseMethodId]);

    useEffect(() => {
        props.changeFieldValue(BillingFormconstants.FEE_SCHEDULES, props.feeScheduleId ?? 0);
        props.setFeeScheduleId(props.feeScheduleId ?? 0);
    }, [props.feeScheduleId]);

    useEffect(() => {
        if (props.shippingService != undefined && Object.keys(props.shippingService).length) {
            props.changeFieldValue(BillingFormconstants.SHIPPING_SERVICES, props.shippingService);
        }
    }, [props.shippingService]);

    useEffect(() => {
        if (props.isInternalRequest) {
            props.setDisableFeeScheduleDropdown(true);
            props.setDisableReleaseMethodDropdown(true);
            props.setDisableShippingDropdown(true);
        } else {
            props.setDisableFeeScheduleDropdown(false);
            props.setDisableReleaseMethodDropdown(false);
            props.setDisableShippingDropdown(props.releaseMethodId === 2);
        }
    }, [props.isInternalRequest]);

    useEffect(() => {
        if (props.updateDeliveryInstructionsStatus === API_SUCCESS) {
            toast.success("Delivery Instructions Saved");
        }
        if (props.updateDeliveryInstructionsStatus === API_FAILURE) {
            toast.error("Delivery Instructions Not Saved");
        }
    }, [props.updateDeliveryInstructionsStatus]);

    useEffect(() => {
        props.setDisableRemoveCertification(!(props.certificationTemplateValue && props.certificationTemplateValue != "-9999"));
    }, [props.certificationTemplateValue]);

    return null;
};

export default DataEntryDetailsRightPaneBillingSection;
